export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";